import { type RegistryInterface } from "silver";

export interface BookLaunchData {
	callingBand?: number;
	callingUrl?: string;
}

const LAUNCH_DATA_KEY = "book_launch_data_";

function getBookLaunchDataKey(archiveCode: string): string {
	return LAUNCH_DATA_KEY + archiveCode;
}

export class BookLaunchDataService {
	constructor(
		private storage: RegistryInterface<BookLaunchData>
	) { }

	public setBookLaunchDataForBook(archiveCode: string, bookLaunchData: BookLaunchData): void {
		const userStorageKey = getBookLaunchDataKey(archiveCode);
		this.storage.set(userStorageKey, bookLaunchData);
	}

	public getBookLaunchDataForBook(archiveCode: string): BookLaunchData|undefined {
		const bookStorageKey = getBookLaunchDataKey(archiveCode);
		return this.storage.get(bookStorageKey);
	}
}
